<template>

    <v-section name="Color" :expanded="expanded">
        <v-action-color type="color" />
        <v-action-color type="background-color" />
    </v-section>

</template>

<script>

import ActionColor from './../actions/ActionColor';
import Section from './Section';

export default {

    components: {
        'v-action-color': ActionColor,
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

}

</script>